import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import App from "@/App"
import { ErrorBoundary } from "@/components/ErrorBoundary"
import { instalarCapturaGlobal } from "@/lib/logger"
import "@/index.css"

// Antes de montar nada: si el arranque mismo revienta, tambien queda registrado.
instalarCapturaGlobal()

const container = document.getElementById("root")
if (!container) throw new Error("No se encontro el elemento #root en index.html")

createRoot(container).render(
  <StrictMode>
    {/*
      El limite mas externo, por fuera de los providers y del router. Es el que
      convierte una pantalla en blanco —el peor final posible para una app
      contable— en un mensaje que dice que paso y como seguir.
    */}
    <ErrorBoundary ambito="raiz">
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
